/**
 * Utilitário para encriptar/descriptografar IDs para uso em URLs.
 * Usa as funções de criptografia existentes do tokenCrypto com encoding URL-safe.
 */

import { encryptToken, decryptToken } from './tokenCrypto';

/**
 * Converte base64 para base64url (URL-safe)
 * Substitui + por -, / por _, e remove padding =
 */
function base64ToBase64Url(base64: string): string {
  return base64
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

/**
 * Converte base64url para base64
 * Substitui - por +, _ por /, e adiciona padding =
 */
function base64UrlToBase64(base64url: string): string {
  let base64 = base64url
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  
  // Adiciona padding se necessário
  while (base64.length % 4) {
    base64 += '=';
  }
  
  return base64;
}

/**
 * Encripta um ID para uso em URL.
 * @param id O ID em texto plano
 * @returns Promise com o ID encriptado e codificado para URL
 */
export async function encryptIdForUrl(id: string): Promise<string> {
  if (!id) return '';
  const encrypted = await encryptToken(id);
  return base64ToBase64Url(encrypted);
}

/**
 * Descriptografa um ID de URL.
 * @param encryptedId O ID encriptado e codificado para URL
 * @returns Promise com o ID em texto plano, ou string vazia em caso de falha
 */
export async function decryptIdFromUrl(encryptedId: string): Promise<string> {
  if (!encryptedId) return '';
  const base64 = base64UrlToBase64(encryptedId);
  return await decryptToken(base64);
}
